<dp-header [title]="title" [rightActions]="rightActions" [leftActions]="leftActions" (checklistOptionChanged)="onChecklistOptionChanged($event)"></dp-header>

@if (isSearchVisible()) {
    <dp-search [searchAvailableOptions]="searchAvailableOptions" [showSavedSearchButtons]="false"
        (searchInfo)="sendSearch($event)" (clearResults)="clearSearch()" (hide)="hideSearch()" (selectedFiltersInitialized)="onSelectedFiltersInitialized($event)"
        (possibleFiltersInitialized)="onPossibleFiltersInitialized($event)">
    </dp-search>
}